module.exports = __webpack_public_path__ + "static/media/solutions-bg.350c662c.jpg";